import { render, staticRenderFns } from "./StockDashboard.vue?vue&type=template&id=9b78da66&scoped=true"
import script from "./StockDashboard.vue?vue&type=script&lang=js"
export * from "./StockDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b78da66",
  null
  
)

export default component.exports